(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_cs-image"] && !Shopify.designMode) return;
  try {
    (function () {
  let observer = null;

  // Trigger animation on a single element
  function triggerAnimation(el) {
    el.classList.remove('is-visible');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.classList.add('is-visible');
      });
    });
  }

  function csInitImageAnimations() {
    // Disconnect old observer before re-initialising to avoid duplicates
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    const elements = document.querySelectorAll('.cs-animate');
    if (!elements.length) return;

    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add class when element enters view
          entry.target.classList.add('is-visible');
        } else {
          // Remove class when element leaves view so it re-animates next time
          entry.target.classList.remove('is-visible');
        }
      });
    }, { threshold: 0.1 });

    elements.forEach(el => {
      observer.observe(el);

      // If already in viewport on init, animate in after paint
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            el.classList.add('is-visible');
          });
        });
      }
    });
  }

  // ── Initial page load ──────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', csInitImageAnimations);
  } else {
    csInitImageAnimations();
  }

  // ── Shopify Theme Editor events ────────────────────────────────────────────

  // Fires when a section is re-rendered after saving a setting change
  document.addEventListener('shopify:section:load', csInitImageAnimations);

  // Fires when a section is selected in the editor sidebar → replay animation
  document.addEventListener('shopify:section:select', function (e) {
    const elements = e.target ? e.target.querySelectorAll('.cs-animate') : [];
    elements.forEach(triggerAnimation);
  });

  // Fires when a block is selected in the editor sidebar → replay animation
  document.addEventListener('shopify:block:select', function (e) {
    const elements = e.target ? e.target.querySelectorAll('.cs-animate') : [];
    elements.forEach(triggerAnimation);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__imageBlockInit) return;
    window.__imageBlockInit = true;

    // ── Pending rAF tracker — prevents reset/trigger races ───────────────────
    const pendingFrames = new WeakMap();

    // ── Helpers ──────────────────────────────────────────────────────────────

    function triggerAnimation(block) {
      // Cancel any in-flight rAF from a previous trigger call so a
      // mid-flight reset followed immediately by another trigger does not
      // leave the block in an inconsistent state.
      if (pendingFrames.has(block)) {
        cancelAnimationFrame(pendingFrames.get(block));
        pendingFrames.delete(block);
      }

      // Clear the inline transition suppression set by resetAnimation.
      block.style.transition = '';

      // Two rAF calls ensure the browser has painted the reset state before
      // re-enabling the transition, avoiding a flash.
      const id = requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          block.classList.add('image-block--animated');
          pendingFrames.delete(block);
        });
      });

      pendingFrames.set(block, id);
    }

    function resetAnimation(block) {
      // Cancel any pending trigger so a trigger→reset sequence that completes
      // before the double-rAF fires does not re-add the animated class.
      if (pendingFrames.has(block)) {
        cancelAnimationFrame(pendingFrames.get(block));
        pendingFrames.delete(block);
      }

      // Suppress transition during reset so there is no visible reverse-animation.
      block.style.transition = 'none';
      block.classList.remove('image-block--animated');
    }

    // ── Per-block setup ───────────────────────────────────────────────────────

    function setupBlock(block) {
      const parentSlide = block.closest('slideshow-slide');

      if (parentSlide) {
        // ── Block is inside a slideshow slide ────────────────────────────────
        //
        // IntersectionObserver is unreliable here because inactive slides are
        // off-screen via CSS transform — the IO may fire immediately for all
        // slides at once, or never for later slides.
        //
        // Instead we watch for the `aria-hidden` attribute that the slideshow
        // component toggles when switching slides.

        const mo = new MutationObserver(() => {
          if (parentSlide.getAttribute('aria-hidden') === 'true') {
            resetAnimation(block);
          } else {
            triggerAnimation(block);
          }
        });

        mo.observe(parentSlide, { attributes: true, attributeFilter: ['aria-hidden'] });

        // Fire immediately only if the slide is already marked as visible.
        // We intentionally do NOT fire when aria-hidden is absent/undefined —
        // that is the pre-init state where the slideshow has not yet stamped
        // its aria attributes. Triggering at that point would animate every
        // image at once, including images in slides that will become hidden.
        if (parentSlide.getAttribute('aria-hidden') === 'false') {
          triggerAnimation(block);
        }

      } else {
        // ── Standalone block (not inside a slideshow) ────────────────────────
        // Classic IntersectionObserver — fires once when scrolled into view.

        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                triggerAnimation(block);
                io.unobserve(block);
              }
            });
          },
          { threshold: 0.15 }
        );

        io.observe(block);
      }
    }

    // ── Scan & initialise ─────────────────────────────────────────────────────

    function observeBlocks() {
      document
        .querySelectorAll('.image-block--animate:not(.image-block--observed)')
        .forEach((block) => {
          block.classList.add('image-block--observed');
          setupBlock(block);
        });
    }

    function init() {
      // Wait for the slideshow-slide custom element to upgrade before scanning.
      // This ensures aria-hidden is already stamped on inactive slides by the
      // time setupBlock reads it, avoiding the race where every image animates
      // at once because aria-hidden was not yet present.
      if (window.customElements) {
        customElements.whenDefined('slideshow-slide').then(observeBlocks);
      } else {
        // Fallback for environments without custom elements support.
        observeBlocks();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-scan when the Shopify theme editor adds or reloads blocks/sections.
    // We temporarily clear the init flag so newly added blocks are picked up.
    function editorRescan() {
      window.__imageBlockInit = false;
      observeBlocks();
      window.__imageBlockInit = true;
    }

    document.addEventListener('shopify:block:select', editorRescan);
    document.addEventListener('shopify:section:load', editorRescan);
  })();
  } catch(e) { console.error(e); }
})();

})();
